import React from "react";
import PlatformAchievements from "./PlatformAchievements";
import Volunteer from "./Volunteer";

const AchievementsAndVolunteer = () => {
  return (
    <div className="flex flex-col gap-8 md:gap-16 mb-20">
      <Volunteer />
      <PlatformAchievements />
    </div>
  );
};

export default AchievementsAndVolunteer;
